export { RippleDirective } from './ripple-effect.directive';
export { RippleModule } from './ripple.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/ripple/index.js
// module id = ../../../../angular-bootstrap-md/ripple/index.js
// module chunks = 3